import validationRules from '../../../utilities/validationRules';
import uploadRecipientsFormResources from './uploadRecipientsFormResources';

export const recipientsFileRequired = validationRules.fileRequired(
    uploadRecipientsFormResources.labelRecipientsFile
);